import React, {useState} from 'react';

import {labels} from '../../../../../../util/utils';

import {IconoirBell, IconoirMail, IconoirNavArrowDown, IconoirNavArrowUp} from '@ey-xd/motif-icon';

import Button from '../../../../../CoreWrappers/Button';
import MotifAccordion from '@ey/motif-react-wrapper/Accordion';
import MotifIcon from '@ey/motif-react-wrapper/Icon';

import OutputText from '@ey/canvascoreservices/OutputText';

import StyledMessageAccordion from './StyledMessageAccordion';
import MessageAccordionContent from '../MessageAccordionContent';
import Ellipsis from '../../../../../Common/Ellipsis/Ellipsis';
import Options from './Options';

const MessageAccordion = ({
	id,
	isEmail,
	sentBy,
	from,
	date,
	time,
	subject,
	contactsList,
	entitiesList,
	countriesList,
	groupRolesList,
	engagementsList,
	serviceLineList,
	rolesList,
	fromEngagement,
	message,
	link,
	hideMessageLog
}) => {
	const [open, setOpen] = useState(false);

	const renderOutputText = (text, light = false) => {
		return (
			<OutputText body2 light={light}>
				<Ellipsis content={text} />
			</OutputText>
		);
	};

	const renderHeaderTrigger = () => {
		const labelTo = isEmail ? labels.emailTo : labels.notificationTo;

		const toOutputLabel = renderOutputText(labelTo);
		const toOutputValue = renderOutputText(
			contactsList?.length > 1
				? `${contactsList?.length} ${labels.multiContatcsLowerCase}`
				: `${contactsList?.length} ${labels.singleContactLowerCase}`
		);

		const sentByOutputLabel = renderOutputText(labels.sentBy, true);
		const sentByOutputValue = renderOutputText(sentBy);

		const fromOutputLabel = renderOutputText(labels.from, true);
		const fromOutputValue = renderOutputText(from.entityName);

		const dateOutputLabel = renderOutputText(labels.date, true);
		const dateOutputValue = renderOutputText(date);

		const timeOutputLabel = renderOutputText(labels.time, true);
		const timeOutputValue = renderOutputText(time);

		const subjectOutputLabel = renderOutputText(labels.subject, true);
		const subjectOutputValue = renderOutputText(subject);

		const renderNotificationToIcon = () => {
			const props = {
				src: isEmail ? IconoirMail : IconoirBell,
				title: isEmail ? labels.email : labels.notification,
				className: 'notification-to-icon'
			};
			return <MotifIcon {...props} />;
		};

		const renderOptions = () => {
			const props = {
				id,
				hideMessageLog,
				contactsList,
				isEmail,
				subject,
				from,
				fromEngagement,
				message,
				link,
				filters: {
					entitiesList,
					countriesList,
					groupRolesList,
					engagementsList,
					serviceLineList,
					rolesList
				}
			};

			return <Options {...props} />;
		};

		const onClickHandler = (e) => {
			if (e.target.closest('.generate-message-modal') === null && e.target.closest('.options') === null) setOpen(!open);
		};

		return (
			<section className="header-container" onClick={onClickHandler}>
				<section className="notification-to content-flex">
					{renderNotificationToIcon()}
					{toOutputLabel}
					{toOutputValue}
				</section>
				<section className="sent-by content-flex">
					{sentByOutputLabel}
					{sentByOutputValue}
				</section>
				<section className="from content-flex">
					{fromOutputLabel}
					{fromOutputValue}
				</section>
				<section className="date content-flex">
					{dateOutputLabel}
					{dateOutputValue}
				</section>
				<section className="time content-flex">
					{timeOutputLabel}
					{timeOutputValue}
				</section>
				<section className="options">{renderOptions()}</section>
				{!open && (
					<section className="subject content-flex">
						{subjectOutputLabel}
						{subjectOutputValue}
					</section>
				)}
				{renderCaret()}
			</section>
		);
	};

	const renderCaret = () => {
		const props = {
			svg: open ? IconoirNavArrowUp : IconoirNavArrowDown,
			className: 'custom-accordion-caret',
			variant: 'ghost'
		};
		return (
			<div className="chevron">
				<Button {...props} />
			</div>
		);
	};

	const renderAccordion = () => {
		const accordionProps = {
			open: open,
			onOpen: () => null,
			onClose: () => null
		};

		return (
			<MotifAccordion {...accordionProps}>
				{renderHeaderTrigger()}
				{open && renderAccordionContent()}
			</MotifAccordion>
		);
	};

	const renderAccordionContent = () => {
		const props = {
			subject,
			isEmail,
			contactsList,
			entitiesList,
			countriesList,
			groupRolesList,
			engagementsList,
			serviceLineList,
			rolesList
		};

		return <MessageAccordionContent {...props} />;
	};

	return (
		<StyledMessageAccordion isOpen={open} className="msg-accordion-wrapper">
			{renderAccordion()}
		</StyledMessageAccordion>
	);
};

export default MessageAccordion;
